module.exports = __webpack_public_path__ + "prod/1.42.2/img/success_exam3.49dd24fc.png";